"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VolumeMenuButtonControl = void 0;
var React = __importStar(require("react"));
var react_1 = require("@xstate/react");
var classnames_1 = __importDefault(require("classnames"));
var volume_bar_1 = require("../volume-control/volume-bar");
var video_context_1 = require("../../context/video-context");
var selectors_1 = require("../../selectors");
var VolumeMenuButtonControl = function (props) {
    var className = props.className, alwaysShowVolume = props.alwaysShowVolume;
    var _a = React.useState(alwaysShowVolume), isActive = _a[0], setActive = _a[1];
    var videoService = (0, video_context_1.useVideo)();
    var volume = (0, react_1.useSelector)(videoService, selectors_1.selectVolume);
    var muted = (0, react_1.useSelector)(videoService, selectors_1.selectMuted);
    var level = volumeLevel();
    function volumeLevel() {
        var level = 3;
        if (volume === 0 || muted) {
            level = 0;
        }
        else if (volume < 0.33) {
            level = 1;
        }
        else if (volume < 0.67) {
            level = 2;
        }
        return level;
    }
    function handleClick() {
        videoService.send('TOGGLE_MUTE');
    }
    function handleFocus() {
        setActive(true);
    }
    function handleBlur() {
        !alwaysShowVolume && setActive(false);
    }
    return (React.createElement("div", { className: "cueplayer-react-volume-control" },
        React.createElement("button", { onFocus: handleFocus, onBlur: handleBlur, onMouseEnter: handleFocus, onMouseLeave: handleBlur, title: muted ? 'Unmute' : 'Mute', "aria-label": muted ? 'Unmute' : 'Mute', role: "button", onClick: handleClick, className: (0, classnames_1.default)(className, {
                'cueplayer-react-vol-muted': muted,
                'cueplayer-react-vol-0': level === 0 && !muted,
                'cueplayer-react-vol-1': level === 1,
                'cueplayer-react-vol-2': level === 2,
                'cueplayer-react-vol-3': level === 3,
            }, 'cueplayer-react-volume-menu-button', 'cueplayer-react-control', 'cueplayer-react-button', 'cueplayer-react-menu-button') }),
        React.createElement(volume_bar_1.VolumeBar, __assign({ onMouseEnter: handleFocus, onMouseLeave: handleBlur, isActive: isActive }, props))));
};
exports.VolumeMenuButtonControl = VolumeMenuButtonControl;
